import { api } from "../lib";

export interface AccessioningScanSession {
  id: string;
  caseId: string;
  workstationId: string;
  deviceId: string;
  status: "pending" | "attached" | "cancelled" | "expired";
  expiresAt: string;
  attachedFileId: string | null;
}

export interface StartAccessioningScanRequest {
  caseId: string;
  workstationId: string;
  deviceId: string;
  clientRequestId: string;
}

export const accessioningScanSessionService = {
  start: (request: StartAccessioningScanRequest) =>
    api.post<AccessioningScanSession>("/accessioning-scans", request),

  getPresignedUrl: (sessionId: string, fileName: string, contentType: string) =>
    api.post<{ url: string; key: string }>(
      `/accessioning-scans/${sessionId}/presigned-url`,
      { fileName, contentType }
    ),

  attach: (sessionId: string, file: File) =>
    api.post<AccessioningScanSession>(
      `/accessioning-scans/${sessionId}/attach`,
      {
        fileName: file.name,
        mimeType: file.type,
        size: file.size,
      }
    ),

  cancel: (sessionId: string) =>
    api.post<AccessioningScanSession>(
      `/accessioning-scans/${sessionId}/cancel`
    ),
};
